<footer class="DTX_FOOTER {{ footerContent.CssClasses }} p-0 container-fluid">
    @for (row of footerContent.Rows; track row) {
        <app-row [row]="row" />
    }
</footer>
